function getQueryParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}
function getCookie(name) {
  const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[2]) : null;
}

async function generateCartUrl() {
  const res = await fetch("/cart.json");
  const data = await res.json();
  if (!data.items || !Array.isArray(data.items)) {
    throw new Error("Unexpected cart data");
  }
  const items = data.items.map((i) => `${i.variant_id}:${i.quantity}`);
  // build permalink with storefront=true
  let url = `${window.location.origin}/cart/${items.join(",")}?storefront=true`;
  const provider = getQueryParam("provider") || getCookie("provider");
  if (provider) url += `&provider=${encodeURIComponent(provider)}`;
  return url;
}

document.addEventListener("click", async function (e) {
  if (e.target.closest("#share-cart-link")) {
    e.preventDefault();
    const overlay = document.getElementById("share-modal-overlay");
    const urlInput = document.getElementById("share-cart-url");
    try {
      const link = await generateCartUrl();
      urlInput.value = link;
      overlay.style.display = "block";
      urlInput.select();
    } catch (err) {
      console.error("Error generating share link:", err);
      alert("Couldn't build your link—please try again.");
    }
  }

  if (e.target.closest("#share-modal-close")) {
    document.getElementById("share-modal-overlay").style.display = "none";
  }

  if (e.target === document.getElementById("share-modal-overlay")) {
    e.target.style.display = "none";
  }

  if (e.target.closest("#copy-cart-url")) {
    e.preventDefault();
    const urlInput = document.getElementById("share-cart-url");
    const copyBtn = document.getElementById("copy-cart-url");
    navigator.clipboard
      .writeText(urlInput.value)
      .then(() => {
        copyBtn.textContent = "Copied!";
        setTimeout(() => {
          copyBtn.textContent = "Copy Link";
        }, 2000);
      })
      .catch(() => {
        alert("Copy failed—please copy the link manually.");
      });
  }
});
